export default __webpack_public_path__ + "static/media/Footpad's Legguards of the Hidden Palace.dac395de.jpg";